import React from "react";
import { useIntl } from "react-intl";
import useBackground from "../../../../util/useBackground";
import useFooter from "../../../../util/useFooter";
import useHeader from "../../../../util/useHeader";
import usePageTitle from "../../../../util/usePageTitle";
import useServicesPageValuatedQuery from "./hooks/useServicePageNumValuedQuery";
import useServicesPageFilters from "./hooks/useServicesPageFilters";
import useServicesPageNewQuery from "./hooks/useServicesPageNumNewQuery";
import useServicesPageQuery from "./hooks/useServicesPageQuery";
import ServicesPage from "./ServicesPage";

interface IServicePageContainerProps {}

const ServicePageContainer = (props: IServicePageContainerProps) => {
  const { formatMessage } = useIntl();

  useHeader({
    type: "hidden",
  });
  useFooter({
    type: "hidden",
  });
  useBackground("cuideo");
  usePageTitle(
    formatMessage({
      id: "ServicesPage.Services",
      defaultMessage: "Servicios",
    })
  );

  const { filters, setFilters } = useServicesPageFilters();

  const servicesQuery = useServicesPageQuery(filters);
  const servicesNewQuery = useServicesPageNewQuery(filters);
  const servicesValuatedQuery = useServicesPageValuatedQuery(filters);
  // const servicesFollowUpQuery = useServicesPageFollowUpQuery(filters);

  const handlePageChange = (event: any, newPage: number) => {
    setFilters({ ...filters, page: newPage });
  };

  const handleDelaySet = () => {
    servicesQuery.refetch();
    servicesNewQuery.refetch();
    servicesValuatedQuery.refetch();
  };

  if (!filters.ready) {
    return null;
  }

  return (
    <ServicesPage
      onDelaySet={handleDelaySet}
      filters={filters}
      setFilters={setFilters}
      services={servicesQuery.data?.services ?? []}
      totalServices={servicesQuery.data?.totalItems ?? 0}
      isLoading={servicesQuery.isLoading}
      queryError={servicesQuery.error}
      newServices={{
        totalServices: servicesNewQuery.data?.totalItems ?? 0,
        isLoading: servicesNewQuery.isLoading,
        queryError: servicesNewQuery.error,
      }}
      valuatedServices={{
        totalServices: servicesValuatedQuery.data?.totalItems ?? 0,
        isLoading: servicesValuatedQuery.isLoading,
        queryError: servicesValuatedQuery.error,
      }}
      // followUpServices={{
      //   totalServices: servicesFollowUpQuery.data?.totalItems ?? 0,
      //   isLoading: servicesFollowUpQuery.isLoading,
      //   queryError: servicesFollowUpQuery.error,
      // }}
      onPageChange={handlePageChange}
    />
  );
};

export default ServicePageContainer;
